module.exports = __webpack_public_path__ + "img/avbuilder_expandcontractphoto.325725f1.svg";